import { Autocomplete } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { GET_DOCUMENT_TEMPLATES } from 'src/graphql/documentTemplates.graphql'

interface DocumentTemplateSelectProps {
  value: string
  onChange: (value: string) => void
  onSelectTemplate: (template) => void
}

const DocumentTemplateSelect = ({
  value,
  onChange,
  onSelectTemplate,
}: DocumentTemplateSelectProps) => {
  const { data } = useQuery(GET_DOCUMENT_TEMPLATES)

  const templates = data?.documentTemplates || []
  const options = templates.map((t) => ({
    value: t.documentTemplateId,
    label: t.documentName,
  }))

  const handleOptionSubmit = (val: string) => {
    const template = templates.find((t) => t.documentTemplateId === val)
    if (template) {
      onSelectTemplate(template)
    }
  }

  return (
    <Autocomplete
      className="col-span-2"
      variant="unstyled"
      size="xs"
      placeholder="Document Name"
      data={options}
      value={value}
      onChange={onChange}
      onOptionSubmit={handleOptionSubmit}
    />
  )
}

export default DocumentTemplateSelect
